// TODO: Handle server errors. Now user can't proceed if server responded with
// error

import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Lang } from '../../types/common-types'
import { State } from '../../state-actions-reducers'
import AccountForm from '../../types/account-form.types'
import CompanyScreenTwoKzt from './Company/KztRegistration/CompanyScreenTwo'
import CompanyScreenTwoRus from './Company/RusRegistration/CompanyScreenTwo'
import CompanyScreenTwoKgz from './Company/KgzRegistration/CompanyScreenTwo'

interface Props {
  lang: Lang
  accountForm: AccountForm
}

/* THE COMPONENT */
function FiscalScreenTwo({
  lang,
  accountForm,
}: Props) {
  const { watch } = useFormContext<State>()
  const state = watch()

  return (
    <>
      {// Казахстан
      state.countryRegistration === '398' ? (
        <CompanyScreenTwoKzt
          lang={lang}
          accountForm={accountForm}
        />
      ) : // Киргизия
      state.countryRegistration === '417' ? (
        <CompanyScreenTwoKgz
          lang={lang}
          accountForm={accountForm}
        />
      ) : (
        <CompanyScreenTwoRus
          lang={lang}
          accountForm={accountForm}
        />
      )}
    </>
  )
}

export default FiscalScreenTwo
